import React from 'react';
import { GetForm_vm_form_formItems_VOLUNTEER_FormItemFieldType_field as FormItemFieldType } from '../../../__generated__/GetForm';
import { AttachmentFieldPreview } from '../../../../admin-console/admin-console-content-pages/admin-console-volunteer-profile/form-builder/task-list/task-items/task-item-fields/AttachmentFieldPreview';
import { CheckboxFieldPreview } from '../../../../admin-console/admin-console-content-pages/admin-console-volunteer-profile/form-builder/task-list/task-items/task-item-fields/CheckboxFieldPreview';
import { CrossTaskDynamicFieldPreview } from '../../../../admin-console/admin-console-content-pages/admin-console-volunteer-profile/form-builder/task-list/task-items/task-item-fields/CrossTaskDynamicFieldPreview';
import { DropdownFieldPreview } from '../../../../admin-console/admin-console-content-pages/admin-console-volunteer-profile/form-builder/task-list/task-items/task-item-fields/DropdownFieldPreview';
import { MultipleChoiceFieldPreview } from '../../../../admin-console/admin-console-content-pages/admin-console-volunteer-profile/form-builder/task-list/task-items/task-item-fields/MultipleChoiceFieldPreview';
import { QuizFieldPreview } from '../../../../admin-console/admin-console-content-pages/admin-console-volunteer-profile/form-builder/task-list/task-items/task-item-fields/QuizFieldPreview';
import { TextFieldPreview } from '../../../../admin-console/admin-console-content-pages/admin-console-volunteer-profile/form-builder/task-list/task-items/task-item-fields/TextFieldPreview';
import { SignatureFieldPreview } from '../../../../admin-console/admin-console-content-pages/admin-console-volunteer-profile/form-builder/task-list/task-items/task-item-fields/SignatureFieldPreview';
import { RatingFieldPreview } from '../../../../admin-console/admin-console-content-pages/admin-console-volunteer-profile/form-builder/task-list/task-items/task-item-fields/RatingFieldPreview';
import { YesNoFieldPreview } from '../../../../admin-console/admin-console-content-pages/admin-console-volunteer-profile/form-builder/task-list/task-items/task-item-fields/YesNoFieldPreview';
import { LinearScaleFieldPreview } from '../../../../admin-console/admin-console-content-pages/admin-console-volunteer-profile/form-builder/task-list/task-items/task-item-fields/LinearScaleFieldPreview';
import { NpsFieldPreview } from '../../../../admin-console/admin-console-content-pages/admin-console-volunteer-profile/form-builder/task-list/task-items/task-item-fields/NpsFieldPreview';
import { MatrixFieldPreview } from '../../../../admin-console/admin-console-content-pages/admin-console-volunteer-profile/form-builder/task-list/task-items/task-item-fields/MatrixFieldPreview';

interface FormItemFieldProps {
  field: FormItemFieldType;
  isDragging: boolean;
}

export function FormItemField({ field, isDragging }: FormItemFieldProps) {
  switch (field.__typename) {
    case 'VOLUNTEER_ShortTextTaskFieldType':
    case 'VOLUNTEER_LongTextTaskFieldType':
    case 'VOLUNTEER_NumberTaskFieldType':
    case 'VOLUNTEER_DateTaskFieldType':
    case 'VOLUNTEER_TimeTaskFieldType':
    case 'VOLUNTEER_AddressTaskFieldType':
    case 'VOLUNTEER_EmailTaskFieldType':
    case 'VOLUNTEER_UrlTaskFieldType':
    case 'VOLUNTEER_PhoneTaskFieldType':
      return <TextFieldPreview />;
    case 'VOLUNTEER_AttachmentTaskFieldType':
      return <AttachmentFieldPreview />;
    case 'VOLUNTEER_FormMultipleChoiceTaskFieldType':
      return <MultipleChoiceFieldPreview field={field} isDragging={isDragging} />;
    case 'VOLUNTEER_FormCheckboxTaskFieldType':
      return <CheckboxFieldPreview field={field} isDragging={isDragging} />;
    case 'VOLUNTEER_FormDropdownTaskFieldType':
      return <DropdownFieldPreview field={field} isDragging={isDragging} />;
    case 'VOLUNTEER_FormQuizTaskFieldType':
      return <QuizFieldPreview field={field} isDragging={isDragging} />;
    case 'VOLUNTEER_SignatureTaskFieldType':
      return <SignatureFieldPreview />;
    case 'VOLUNTEER_RatingTaskFieldType':
      return <RatingFieldPreview />;
    case 'VOLUNTEER_YesNoTaskFieldType':
      return <YesNoFieldPreview />;
    case 'VOLUNTEER_LinearScaleTaskFieldType':
      return (
        <LinearScaleFieldPreview
          minValue={field.minValue}
          maxValue={field.maxValue}
          minLabel={field.minLabel}
          maxLabel={field.maxLabel}
        />
      );
    case 'VOLUNTEER_NpsTaskFieldType':
      return <NpsFieldPreview />;
    case 'VOLUNTEER_FormMatrixTaskFieldType':
      return <MatrixFieldPreview rows={field.rows} columns={field.columns} />;
    case 'VOLUNTEER_CrossTaskDynamicTaskFieldType':
      return <CrossTaskDynamicFieldPreview field={field} isDragging={isDragging} />;
    default:
      return null;
  }
}
